const WORKOUT_SECTION_ENDPOINT = {
  ROOT: '/workout-sections',
  BY_ID: '/workout-section/:id'
}

export { WORKOUT_SECTION_ENDPOINT }
